// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trustpilot-quote_wrapper___5Tl7","hideOnSmallScreen":"trustpilot-quote_hideOnSmallScreen__Ib6Bk","hideOnLargeScreen":"trustpilot-quote_hideOnLargeScreen__Ii5EC"};